import React from 'react';

// Remove the old ForceSapLogoWhite component
// const ForceSapLogoWhite = () => { ... };

// ... Other Icons (LinkedInIcon, TwitterIcon, etc.) ...
const LinkedInIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg>
);
const TwitterIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>
);
const FacebookIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path></svg>
);
const InstagramIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path></svg>
);
const GithubIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 496 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path></svg>
);
const ChevronRightIcon = () => (
    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 320 512" className="mr-2 text-primary" height="10" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg>
);

const footerLinks = {
    services: [
        { name: "Salesforce", href: "#services" },
        { name: "SAP Implementation", href: "#services" },
        { name: "Dynamics 365", href: "#services" },
        { name: "Cloud Services", href: "#services" },
    ],
    solutions: [
        { name: "CRM Solutions", href: "#solutions" },
        { name: "ERP Systems", href: "#solutions" },
        { name: "Digital Transformation", href: "#solutions" },
        { name: "Cloud Migration", href: "#solutions" },
    ],
    company: [
        { name: "About Us", href: "#about" },
        { name: "Contact", href: "#contact" },
        { name: "Careers", href: "#" }, // Placeholder link
        { name: "Partners", href: "#" }, // Placeholder link
    ],
    legal: [
        { name: "Privacy Policy", href: "#" },
        { name: "Terms of Service", href: "#" },
        { name: "Cookie Policy", href: "#" },
    ]
};

const socialLinks = [
    { name: "LinkedIn", href: "https://www.linkedin.com/company/forcesap-it-solutions-consulting-private-limited/", Icon: LinkedInIcon },
    { name: "Twitter", href: "https://twitter.com", Icon: TwitterIcon },
    { name: "Facebook", href: "https://facebook.com", Icon: FacebookIcon },
    { name: "Instagram", href: "https://instagram.com", Icon: InstagramIcon },
    { name: "GitHub", href: "https://github.com", Icon: GithubIcon },
];

function Footer() {
    const currentYear = new Date().getFullYear();

    // Encode the address for the Google Maps URL
    const latitude = 22.7645;
    const longitude = 75.8886;
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

    const phoneNumber = "+91 9876543210";
    const emailAddress = "hr@forceapp.com";

    return (
        <footer className="bg-gray-900 text-white">
            <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-6 gap-12">
                    {/* Logo and Description */}
                    <div className="md:col-span-2">
                         {/* Text Logo Implementation */}
                        <div className="mb-4">
                            <span className="text-2xl font-bold tracking-tight">
                                <span className="text-gray-400 hover:text-gray-300 transition-colors">Eco</span>
                                <span className="text-sky-400 hover:text-sky-300 transition-colors">Peak</span>
                                <span className="text-gray-100 hover:text-white transition-colors"> Force</span>
                                <span className="text-sky-400 hover:text-sky-300 transition-colors">SAP</span>
                            </span>
                        </div>
                        <p className="mt-5 text-gray-400 text-sm max-w-md">
                            Empowering businesses with innovative enterprise solutions across Salesforce, SAP, and Microsoft Dynamics 365.
                        </p>
                        {/* Social Links */}
                        <div className="mt-8 flex space-x-3">
                            {socialLinks.map((link) => (
                                <a
                                    key={link.name}
                                    href={link.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label={`Visit our ${link.name} page`}
                                    className="w-10 h-10 bg-gray-800 hover:bg-primary hover:scale-110 rounded-full flex items-center justify-center text-white transition-all duration-300"
                                >
                                    <link.Icon />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Footer Links Sections */}
                    {Object.keys(footerLinks).filter(key => key !== 'legal').map((key) => (
                        <div key={key} className="md:col-span-1">
                           <h3 className="text-lg font-semibold mb-4 capitalize">{key}</h3>
                           <ul>
                               {footerLinks[key].map(link => (
                                   <li key={link.name} className="mb-2">
                                       <a href={link.href} className="text-gray-400 hover:text-white hover:pl-1 flex items-center transition-all duration-200 text-sm">
                                           <ChevronRightIcon />
                                           {link.name}
                                       </a>
                                   </li>
                               ))}
                           </ul>
                       </div>
                    ))}

                    {/* Updated Contact Info */}
                    <div className="md:col-span-1">
                        <h3 className="text-lg font-semibold mb-4">Contact</h3>
                        <address className="text-gray-400 text-sm not-italic space-y-2">
                            {/* Make the address a link to Google Maps */}
                            <a 
                                href={googleMapsUrl} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="hover:text-white transition-colors block"
                                aria-label="View address on Google Maps"
                            >
                                2nd Floor Building no. 216<br/>
                                scheme no. 78-part 2,<br/>
                                vijay nagar- 452010
                            </a>
                    
                            <p>
                                Email: <a href={`mailto:${emailAddress}`} className="hover:text-white transition-colors">{emailAddress}</a>
                            </p>
                        </address>
                    </div>
                </div>

                {/* Newsletter Subscription - Commented Out */}
                {/*
                <div className="border-t border-gray-800 mt-12 pt-8">
                  <div className="max-w-3xl mx-auto">
                    <h3 className="text-lg font-semibold mb-4 text-center">Subscribe to Our Newsletter</h3>
                    <form onSubmit={e => { e.preventDefault(); alert('Subscribed! (Placeholder)'); }}>
                        <div className="flex flex-col sm:flex-row gap-3">
                        <input
                            type="email"
                            placeholder="Your email address"
                            required
                            className="w-full sm:flex-1 px-4 py-3 rounded-md bg-gray-800 border border-gray-700 text-white focus:outline-none focus:border-primary text-sm"
                        />
                        <button type="submit" className="px-6 py-3 bg-primary hover:bg-blue-700 rounded-md font-semibold transition-colors duration-300 text-sm">
                            Subscribe
                        </button>
                        </div>
                    </form>
                  </div>
                </div>
                */}
            </div>

            {/* Bottom Footer */}
             <div className="bg-gray-950 py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center">
                    <p className="text-sm text-gray-500">© {currentYear} EcoPeak ForceSAP IT Solution Pvt Ltd. All rights reserved.</p>
                    <div className="mt-4 sm:mt-0 flex space-x-6 text-sm text-gray-500">
                        {footerLinks.legal.map(link => (
                            <a key={link.name} href={link.href} className="hover:text-gray-400 transition">
                                {link.name}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;